import React, { useState, useEffect } from "react";

function HeightCounter() {
  // State for the first converter: feet/inches to centimeters
  const [converter1, setConverter1] = useState({
    feet: "",
    inches: "",
    centimeters: ""
  });

  // State for the second converter: centimeters to feet/inches
  const [converter2, setConverter2] = useState({
    centimeters: "",
    feet: "",
    inches: ""
  });

  // State for the third converter: inches to feet/inches
  const [converter3, setConverter3] = useState({
    totalInches: "",
    feet: "",
    inches: ""
  });

  // Validation function for numeric inputs
  const validateNumber = (value, maxLength = 5) => {
    if (value === "") return true;
    // Allow numbers with optional decimal point
    const regex = new RegExp(`^\\d*\\.?\\d{0,2}$`);
    return regex.test(value) && value.length <= maxLength;
  };

  // Converter 1: Feet and Inches to Centimeters
  useEffect(() => {
    if (converter1.feet !== "" || converter1.inches !== "") {
      const feetValue = parseFloat(converter1.feet) || 0;
      const inchesValue = parseFloat(converter1.inches) || 0;
      
      // Convert to centimeters: (feet * 12 + inches) * 2.54
      const totalInches = feetValue * 12 + inchesValue;
      const centimeters = totalInches * 2.54;
      
      setConverter1(prev => ({
        ...prev,
        centimeters: centimeters ? centimeters.toFixed(2) : ""
      }));
    }
  }, [converter1.feet, converter1.inches]);

  // Converter 2: Centimeters to Feet and Inches
  useEffect(() => {
    if (converter2.centimeters !== "") {
      const centimetersValue = parseFloat(converter2.centimeters) || 0;
      
      // Convert to total inches: centimeters / 2.54
      const totalInches = centimetersValue / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = (totalInches % 12).toFixed(2);
      
      setConverter2(prev => ({
        ...prev,
        feet: feet ? feet.toString() : "",
        inches: inches !== "0.00" ? inches : ""
      }));
    }
  }, [converter2.centimeters]);

  // Converter 3: Inches to Feet and Inches
  useEffect(() => {
    if (converter3.totalInches !== "") {
      const totalInchesValue = parseFloat(converter3.totalInches) || 0;
      
      const feet = Math.floor(totalInchesValue / 12);
      const inches = (totalInchesValue % 12).toFixed(2);
      
      setConverter3(prev => ({
        ...prev,
        feet: feet ? feet.toString() : "",
        inches: inches !== "0.00" ? inches : ""
      }));
    }
  }, [converter3.totalInches]);

  // Handler for input changes
  const handleInputChange = (converter, setConverter, field, value) => {
    if (validateNumber(value)) {
      setConverter(prev => ({ ...prev, [field]: value }));
    }
  };

  return (
    <div id="height_conveter_calc_tab" role="tabpanel">
      <div className="row mt-2">
        <div id="converter">
          <div className="row">
            {/* Converter 1: Feet and Inches to Centimeters */}
            <div className="col-md-4">
              <div style={{ width: "100%" }}>
                <div className="body-fat-ratio-heading">
                  <h5>Feet and Inches to Centimeters</h5>
                </div>
                <div style={{ backgroundColor: "#F7F7F7", padding: "15px" }}>
                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <label className="control-label mb-2">Feet</label>
                      <input
                        className="form-control"
                        value={converter1.feet}
                        onChange={(e) => 
                          handleInputChange(converter1, setConverter1, "feet", e.target.value)
                        }
                        placeholder="Feet"
                        type="text"
                      />
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label className="control-label mb-2">Inches</label>
                      <input
                        className="form-control"
                        value={converter1.inches}
                        onChange={(e) => 
                          handleInputChange(converter1, setConverter1, "inches", e.target.value)
                        }
                        placeholder="Inches"
                        type="text"
                      />
                    </div>
                    <div className="col-lg-12">
                      <label className="control-label mb-2">Centimeters</label>
                      <input
                        className="form-control"
                        value={converter1.centimeters}
                        readOnly
                        placeholder="Centimeters"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Converter 2: Centimeters to Feet and Inches */}
            <div className="col-md-4">
              <div style={{ width: "100%" }}>
                <div className="body-fat-ratio-heading">
                  <h5>Centimeters to Feet and Inches</h5>
                </div>
                <div style={{ backgroundColor: "#F7F7F7", padding: "15px" }}>
                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <label className="control-label mb-2">Centimeters</label>
                      <input
                        className="form-control"
                        value={converter2.centimeters}
                        onChange={(e) => 
                          handleInputChange(converter2, setConverter2, "centimeters", e.target.value)
                        }
                        placeholder="Centimeters"
                        type="text"
                      />
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label className="control-label mb-2">Feet</label>
                      <input
                        className="form-control"
                        value={converter2.feet}
                        readOnly
                        placeholder="Feet"
                        type="text"
                      />
                    </div>
                    <div className="col-lg-12">
                      <label className="control-label mb-2">Inches</label>
                      <input
                        className="form-control"
                        value={converter2.inches}
                        readOnly
                        placeholder="Inches"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Converter 3: Inches to Feet and Inches */}
            <div className="col-md-4">
              <div style={{ width: "100%" }}>
                <div className="body-fat-ratio-heading">
                  <h5>Inches to Feet and Inches</h5>
                </div>
                <div style={{ backgroundColor: "#F7F7F7", padding: "15px" }}>
                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <label className="control-label mb-2">Inches</label>
                      <input
                        className="form-control"
                        value={converter3.totalInches}
                        onChange={(e) => 
                          handleInputChange(converter3, setConverter3, "totalInches", e.target.value)
                        }
                        placeholder="Inches"
                        type="text"
                      />
                    </div>
                    <div className="col-lg-12 mb-3">
                      <label className="control-label mb-2">Feet</label>
                      <input
                        className="form-control"
                        value={converter3.feet}
                        readOnly
                        placeholder="Feet"
                        type="text"
                      />
                    </div>
                    <div className="col-lg-12">
                      <label className="control-label mb-2">Inches</label>
                      <input
                        className="form-control"
                        value={converter3.inches}
                        readOnly
                        placeholder="Inches"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeightCounter;